import React from "react"
import {
	Form
} from "antd"
import "antd/lib/date-picker/style/index.css"
import AddressInputForm from "../../addressInputForm"
import NRISelect from "../../nsi/NSISelector/NRISelect"
import {
	userActions
} from "../../../store/actions/user"
import {
	socialGroupActions
} from "../../nsi/ReSocialGroupTypes/actions"
import {
	CustomInput
} from "../../../components/CustomInput"
import {
	MaskedInput
} from "../../../components/MaskedInput"
import { useDispatch } from "react-redux"

const PersonFiz = (props) => {
	const { form, user, isRu, i18n, isEmailAnswer, isWrittenAnswer } = props

	const dispatch = useDispatch()

	function getSocGroupByName(val) {
		dispatch(socialGroupActions.getSocialGroupByName({
			pageSize: 10,
			name: val
		}))
	}

	const userNameValidation = {
		pattern: /^[А-ЯЁІ]([а-яёіў]|[-' ][А-ЯЁІЎа-яёіў]+)+$/,
		message: user ? i18n.incorrectNameValue[isRu] : i18n.onlyCyrillicErrorMessage[isRu]
	}


	return (
		<>
			<Form.Item
				initialValue={user ? user.lastName : null}
				label={i18n.lastName[isRu]}
				name="LastName"
				rules={[
					{
						required: true,
						whitespace: true,
						message: i18n.lastNameRequired[isRu]
					},
					userNameValidation
				]}
			>
				<CustomInput 
				disabled = {user ? user.lastName : false}
				placeholder={i18n.lastName[isRu]} />
			</Form.Item>
			<Form.Item
				initialValue={user ? user.firstName : null}
				label={i18n.firstName[isRu]}
				name="FirstName"
				rules={[
					{
						required: true,
						whitespace: true,
						message: i18n.firstNameRequired[isRu]
					},
					userNameValidation
				]}
			>
				<CustomInput 
				disabled = {user ? user.firstName : false} 
				placeholder={i18n.firstName[isRu]} />
			</Form.Item>
			<Form.Item
				initialValue={user ? user.middleName : null}
				label={i18n.middleName[isRu]}
				name="MiddleName"
				rules={[
					userNameValidation
				]}
			>
				<CustomInput 
				disabled = {user ? user.middleName : false}
				placeholder={i18n.middleName[isRu]} />
			</Form.Item>
			<MaskedInput
				form={form}
				className="ant-input-affix-wrapper custom-input"
				initialValue={user ? user.identificationNumber ? user.identificationNumber : ""  : ""}
				label={i18n.ApplicantIdentificationNumber[isRu]}
				fieldName="ApplicantIdentificationNumber"
				correctLength={14}
				mask="9 999999 a 999 aa 9"
				placeholder="0 000000 X 000 XX 0"
				regexForField={/^\d{7}[ABCKEMHАВСКЕМН]\d{3}(PB|BA|BI|РВ|ВА|ВІ)\d$/}
				regexForAllowedSymbols={/^[ABCKEMHPIАВСКЕМНРІ0-9]+$/}
				regexForDeletingSymbols={/\s|_/g}
				enterMessage={i18n.enterIdentificationNumberMessage[isRu]}
        		validateMessage={i18n.validateIdentificationNumberMessage[isRu]}
			/>
			<Form.Item
				required
				initialValue={
					user
						? user.userType
							? [
								"foreign",
								"stateless",
								"citizen"
							].includes(user.userType.name)
								? user.userType
								: null
							: null
						: null
				}
				label={i18n.ApplicantUserType[isRu]}
				name="ApplicantUserType"
				rules={[{ required: true }]}
			>
				<NRISelect
					actions={userActions}
					actionType="getUserTypes"
					itemName="description"
					itemNameBel="descriptionBel"
					itemsName="userTypes"
					params={{
						Names: [
							"foreign",
							"stateless",
							"citizen"
						]
					}}
					placeHolder={i18n.ApplicantUserType[isRu]}
					reducer="userReducer"
					value={form.getFieldValue("ApplicantUserType")}
					onChange={(val) => {
						form.setFieldsValue({ ApplicantUserType: val })
					}}
				/>
			</Form.Item>

			<Form.Item
				initialValue={
					user ? (user.reSocialGroupType ? user.reSocialGroupType : null) : null
				}
				label={i18n.ApplicantReSocialGroupType[isRu]}
				name="ApplicantReSocialGroupType"
			>
				<NRISelect
					actions={socialGroupActions}
					actionType="getSocialGroupTypes"
					itemName="name"
					itemNameBel="nameBel"
					params={{
						page: 1,
						pageSize: 10
					}}
					placeHolder={i18n.ApplicantReSocialGroupType[isRu]}
					reducer="reSocialGroupTypesReducer"
					value={form.getFieldValue("ApplicantReSocialGroupType")}
					onChange={(val) => {
						form.setFieldsValue({ ApplicantReSocialGroupType: val })
					}}
					onSelectSearch={getSocGroupByName}
				/>
			</Form.Item>

			<Form.Item
				initialValue={user ? user.email : null}
				label={i18n.email[isRu]}
				name="Email"
				rules={[
					{
						type: "email",
						required: isEmailAnswer
					}
				]}
			>
				<CustomInput placeholder={i18n.email[isRu]} />
			</Form.Item>

			<AddressInputForm
				noAddressOption
				address={user ? user.address : null}
				disabled={false}
				form={form}
				isWrittenAnswer={isWrittenAnswer}
				placeholder={i18n.address[isRu]}
			/>
			<MaskedInput
				form={form}
				className="ant-input-affix-wrapper custom-input"
				initialValue={user ? user.phoneCode ? user.phoneCode.value + user.mobilePhoneNumber
													: user.mobilePhoneNumber
								   : null
				}
				label={i18n.ApplicantPhone[isRu]}
				fieldName="ApplicantPhone"
				correctLength={13}
				mask="+375 (99) 999-99-99"
				placeholder={"+375 (00) 000-00-00"}
				regexForField={/^\+375((25)|(29)|(33)|(44)|(16)|(17)|(15)|(21)|(22)|(23))[0-9]{7}$/}
				regexForAllowedSymbols={/^[0-9]+$/}
				regexForDeletingSymbols={/[\s_\-()]/g}
				enterMessage={i18n.enterPhoneNumberMessage[isRu]}
        		validateMessage={i18n.validatePhoneNumberMessage[isRu]}
			/>
		</>
	)
}

export default PersonFiz
